import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useRef, useState } from 'react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import EditIcon from '@mui/icons-material/Edit';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import DeviceHubOutlinedIcon from '@mui/icons-material/DeviceHubOutlined';
import { Icon } from '@iconify/react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function OrganizationMoreMenu({ handleClicks, data }) {
  const classes = useStyles();
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton data-testid="organisation-more-menu" ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        sx={{
          '& .MuiListItemText-root > .MuiTypography-root': {
            color: '#000',
            fontWeight: 600,
            fontStyle: 'normal'
          }
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('create_admin');
          }}
          sx={{ color: 'text.secondary' }}
          className={classes.menuItem}
        >
          <ListItemIcon>
            <ControlPointIcon color="info" />
          </ListItemIcon>
          <ListItemText primary="Create Admin" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('device_assign');
          }}
          sx={{ color: 'text.secondary' }}
          className={classes.menuItem}
        >
          <ListItemIcon>
            <DeviceHubOutlinedIcon color="#4caf50" />
          </ListItemIcon>
          <ListItemText primary="Assign Devices" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('edit_organization');
          }}
          sx={{ color: 'text.secondary' }}
          className={classes.menuItem}
        >
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText primary="Edit Organization" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('organization_status');
          }}
          sx={{ color: 'text.secondary' }}
          className={classes.menuItem}
        >
          <ListItemIcon>
            {data ? (
              <UnarchiveOutlinedIcon color="warning" />
            ) : (
              <ArchiveOutlinedIcon color="success" />
            )}
          </ListItemIcon>
          <ListItemText
            primary={data ? 'Inactive' : 'Active'}
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}
